define('glu/grid/comparatorFactory',['require','../util'],function(require) {
    'use strict';


    var util = require('../util'),
        LEFT_FIRST = -1,
        RIGHT_FIRST = 1,
        EQUAL = 0;


    var ascendingCaseInsensitiveComparator = function(a, b) {
            if (typeof a === 'string' && typeof b === 'string') {
                a = a.toUpperCase();
                b = b.toUpperCase();
            }


            if (a < b) {
                return LEFT_FIRST;
            }

            if (a > b) {
                return RIGHT_FIRST;
            }

            if (a === null) {
                a = undefined;
            }

            if (b === null) {
                b = undefined;
            }

            if (a === undefined && b !== undefined) {
                return LEFT_FIRST;
            }

            if (a !== undefined && b === undefined) {
                return RIGHT_FIRST;
            }

            return EQUAL;
        },
        arrayInsensitiveComparator = function(a, b, array) {
            var aIndex = util.indexOf(array, a),
                bIndex = util.indexOf(array, b);

            return ascendingCaseInsensitiveComparator(aIndex, bIndex);
        };

    return {

        ascendingByField: function(field) {
            return function(A, B) {

                var a = A.get(field);
                var b = B.get(field);
                var primarySort = ascendingCaseInsensitiveComparator(a, b);

                if (primarySort !== EQUAL) {
                    return primarySort;
                }

                if (A.gluStableSortIndex !== undefined && B.gluStableSortIndex !== undefined) {
                    return A.gluStableSortIndex < B.gluStableSortIndex ? LEFT_FIRST : RIGHT_FIRST;
                }

                return EQUAL;

            };
        },

        descendingByField: function(field) {
            return function(A, B) {

                var a = A.get(field);
                var b = B.get(field);
                var primarySort = ascendingCaseInsensitiveComparator(a, b) * -1;

                if (primarySort !== EQUAL) {
                    return primarySort;
                }

                if (A.gluStableSortIndex !== undefined && B.gluStableSortIndex !== undefined) {
                    return A.gluStableSortIndex < B.gluStableSortIndex ? LEFT_FIRST : RIGHT_FIRST;
                }

                return EQUAL;

            };
        },

        multiColumnComparator: function(fieldCollection) {
            return function(A, B) {
                var sortForField = function(item) {
                    var a = A.get(fieldCollection.models[item].get('field')),
                        b = B.get(fieldCollection.models[item].get('field')),
                        sortingOrder = fieldCollection.models[item].get('multiColumnSort') ? fieldCollection.models[item].get('multiColumnSort') : 'asc',
                        primarySort;

                    if (util.isArray(sortingOrder)) {
                        primarySort = arrayInsensitiveComparator(a, b, sortingOrder);
                    } else if (sortingOrder === 'asc') {
                        a = a || Infinity;
                        b = b || Infinity;
                        primarySort = ascendingCaseInsensitiveComparator(a, b);
                    } else if (sortingOrder === 'desc') {
                        a = a || -Infinity;
                        b = b || -Infinity;
                        primarySort = ascendingCaseInsensitiveComparator(a, b) * -1;
                    } else if (sortingOrder === 'ascIncludeUndefined') {
                        if (util.isUndefined(a)) {
                            a = Infinity;
                        }
                        if (util.isUndefined(b)) {
                            b = Infinity;
                        }
                        primarySort = ascendingCaseInsensitiveComparator(a, b);
                    }

                    if ((!primarySort) && (item < fieldCollection.length - 1)) {
                        return sortForField(item + 1);
                    }

                    return primarySort;

                };

                return sortForField(0);
            };
        }
    };

});

